<template>
  <q-avatar
    :size="size"
    :color="color"
    text-color="grey-6"
    v-bind="attrs"
  >
    <img
      v-if="url"
      :src="url"
    >
    <div
      v-else-if="profile"
      class="icon-wrapper"
    >
      <q-icon
        :name="teamAccess ? 'far fa-people-group' : 'far fa-circle-user'"
        class="full-width"
      />
    </div>
    <q-icon
      v-else
      name="img:/circle-user.svg"
    />
  </q-avatar>
</template>

<script setup>

import { useAttrs } from 'vue';

const attrs = useAttrs();

defineProps({
  color: {
    type: String,
    default: 'grey-1',
  },
  size: {
    type: String,
    default: '2em',
  },
  url: {
    type: String,
    default: undefined,
  },
  profile: {
    type: Boolean,
    default: false,
  },
  teamAccess: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
.icon-wrapper, i {
  background: var(--q-gradient);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
